import {createSlice} from "@reduxjs/toolkit";
import {apiCall} from "./apiAction";

const slice = createSlice({
    name: 'sectionReport',
    initialState: {
        sectionReports: [],
        count: 0,
        total_pages: 1,
        message: false
    },
    reducers: {
        getAll: (state, action) => {
            state.sectionReports = action.payload.results
            state.count = action.payload.count
            state.total_pages = action.payload.total_pages
        },
        save: (state, action) => {
            state.sectionReports.unshift(action.payload)
            state.message = true
        },
        deleteItem: (state, action) => {
            state.sectionReports = state.sectionReports.filter(item => item.id !== action.payload.id)
            state.message = 'deleted'
        },
        messageReset: (state) => {
            state.message = false
        },
        messageFail: (state) => {
            state.message = 'error'
        },
    }
})

export const getSectionReports = (sectionType, page = 1, pageSize = 20, search = '', regionId = '', viloyatId = '') => apiCall({
    url: `section-reports/?section_type=${sectionType}&page=${page}&page_size=${pageSize}${search ? `&search=${search}` : ''}${regionId ? `&region_id=${regionId}` : ''}${viloyatId ? `&viloyat_id=${viloyatId}` : ''}`,
    method: 'GET',
    onSuccess: slice.actions.getAll.type,
})

export const saveSectionReport = (data) => apiCall({
    url: 'section-reports/',
    method: 'POST',
    onSuccess: slice.actions.save.type,
    onFail: slice.actions.messageFail.type,
    headers: {"Content-Type": "multipart/form-data"},
    data,
})

export const deleteSectionReport = (data) => apiCall({
    url: `section-reports/${data.id}/`,
    method: 'DELETE',
    onSuccess: slice.actions.deleteItem.type,
    onFail: slice.actions.messageFail.type,
})

export default slice.reducer
export const {messageReset} = slice.actions